import React from "react";
import './SettingsControl.css';
import { stickToFooter } from "utilities/js/styling/observerCreator";
import Constants from "utilities/js/Constants";

const settingsIcon = Constants.ICON_SETTINGS;

class SettingsControl extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        disableFixed: props.disableFixed != null ? true : false
    };

    this.toggleSettingsPanel = this.toggleSettingsPanel.bind(this);
  }

  componentDidMount(){
    let settingsContainer = document.querySelector('.settings-panel-button-container')
    // stickToFooter(settingsContainer);
  }
  get buttonContainerClass(){
    return 'settings-panel-button-container ' + (this.state.disableFixed ? 'inline' : 'fixed');
  }

  toggleSettingsPanel(event){
    if(this.props.isOpen){
      this.props.closePanel();
    }else{
      this.props.openPanel();
    }
    event.stopPropagation();
  }

  


  render(){

    return (
      <div className={this.buttonContainerClass}>                            
        <div className="settings-panel-button" onClick={this.toggleSettingsPanel}><img className="settings-icon" alt="open-settings" src={settingsIcon}></img></div>
      </div>
    );
  }
}

export default SettingsControl;
